import React, { useState } from 'react';
import { connect, useSelector } from "react-redux";
import {
    CardBody, Col,Form, FormGroup, Label, Row,
} from 'reactstrap';
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";

import { FL_ONLY_REGISTERED, FL_STATUS } from "../../../components/i18n/formLabels";
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";

import { setFilter } from "../../../redux/actions/generics/IndexedActions";
import { getStateByPath } from "../../../redux/selectors";

const EventControllerFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter, app, udn, category } = componentState?.data;

    const [status, setStatus] = useState( filter?.item?.status ?? true);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            onlyRegistered : onlyRegistered,
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                status: status,
                udn : { id : udn.id }
            }
        }

        if (status !== undefined && status !== null) {
            dataFilter.item.status = status;
        }

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        setStatus(null);
        setOnlyRegistered(null);
        reset();

        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.onlyRegistered;
            delete tmpFilter.item.status;
        }
        props.setFilter(tmpFilter);
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_ONLY_REGISTERED}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(EventControllerFilters)
